import { clearPermissions } from '@/features/userPrefs/userPrefsSlice';
import apis from './apis';
// File for adding API middlewares to intercept and handle API-related actions

/**
 * Middleware to detect changes in the MSAL account and reset API states accordingly.
 *
 * This middleware listens for the 'msalAccount/setAccount' action, which indicates a change
 * in the authenticated user account. When such a change is detected, it compares the previous
 * account's username with the new one.
 *
 * If the account has changed (i.e., the usernames are different), it triggers a reset of all
 * API slices' states using their `resetApiState()` utility. This ensures that cached data
 * associated with the previous account is cleared, preventing data leakage or inconsistencies
 * between users.
 *
 * @param {object} store - The Redux store API object, providing access to getState and dispatch.
 * @returns {function} - A Redux middleware function.
 */
export const accountChangeMiddleware = (store) => (next) => (action) => {
	const prevState = store.getState();

	const result = next(action);

	const accountChangeAction = action.type === 'msalAccount/setAccount';

	if (accountChangeAction) {
		try {
			const prevAccount = prevState?.msalAccount?.account?.username;
			const newAccount = result?.payload?.username;

			if (prevAccount != newAccount) {
				console.log('🧹 Resetting API state ...');
				store.dispatch(clearPermissions());
				apis.forEach((api) => store.dispatch(api.util.resetApiState()));
			}
		} catch (err) {
			console.error('There was an issue resetting API state', err);
		}
	}
	return result;
};
